var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAppleIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#333335"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.851 14C27.8975 14 27.9441 14 27.9932 14C28.1074 15.4104 27.569 16.4643 26.9148 17.2275C26.2728 17.9854 25.3937 18.7205 23.9718 18.609C23.877 17.2187 24.4162 16.243 25.0696 15.4816C25.6756 14.772 26.7865 14.1405 27.851 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1568 28.6781C32.1568 28.6921 32.1568 28.7044 32.1568 28.7176C31.7572 29.9278 31.1873 30.965 30.4917 31.9275C29.8567 32.8014 29.0786 33.9773 27.6893 33.9773C26.4887 33.9773 25.6913 33.2054 24.4609 33.1843C23.1593 33.1632 22.4436 33.8298 21.2536 33.9975C21.1174 33.9975 20.9813 33.9975 20.8478 33.9975C19.974 33.8711 19.2688 33.179 18.755 32.5555C17.24 30.7129 16.0694 28.3329 15.8516 25.2872C15.8516 24.9886 15.8516 24.6909 15.8516 24.3923C15.9438 22.2125 17.0029 20.4402 18.4107 19.5813C19.1537 19.1246 20.1751 18.7356 21.3124 18.9095C21.7998 18.985 22.2978 19.1518 22.7343 19.317C23.1479 19.4759 23.6652 19.7578 24.1553 19.7429C24.4872 19.7332 24.8174 19.5602 25.152 19.4382C26.1322 19.0842 27.0929 18.6785 28.3594 18.8691C29.8813 19.0992 30.9616 19.7754 31.629 20.8187C30.3415 21.6381 29.3237 22.8729 29.4975 24.9816C29.6521 26.897 30.7657 28.0176 32.1568 28.6781Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/apple-icon.603363b0.svg";
export { ForwardRef as ReactComponent };